module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-03.0d4ba7a7.png";